<template>
  <div>
    <div>
      <!-- 左侧搜索 -->
      <div class="display_flex top">
        <div class="search-top">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item>
              <el-input class="w-208" :maxlength="30" v-model="formInline.name" clearable placeholder="名称/拼音">
                <template #suffix>
                  <div class="searchcss">
                    <i class="fa fa-search"></i>
                  </div>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="批号">
              <el-input v-model="formInline.batch_no" clearable />
            </el-form-item>
            <el-form-item label="供货单位">
              <el-select v-model="formInline.supplier" placeholder="请选择" clearable>
                <el-option v-for="item in supplierList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="formInline.check_status" clearable placeholder="请选择">
                <el-option v-for="item in check_statusList" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出库时间">
              <el-date-picker v-model="formInline.backoff_time" type="daterange" range-separator="至"
                start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD" @change="timeChange" />
            </el-form-item>
            <el-form-item label="审核时间">
              <el-date-picker v-model="formInline.backoff_check_time" type="daterange" range-separator="至"
                start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD" @change="timeChanges" />
            </el-form-item>
            <el-form-item label="出库单号">
              <el-input v-model="formInline.out_order_no"
                @input="(v)=>(formInline.out_order_no = v.replace(/[\u4E00-\u9FA5]/g, ''))" clearable />
            </el-form-item>
            <el-form-item label="出库类型:" prop="dict_out_type">
              <el-select clearable placeholder="选择出库类型" v-model="formInline.dict_out_type">
                <el-option v-for="item in dictList[205000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-button class="color-main" type="primary" @click="search()">
              <i class="fa fa-search"></i>查询
            </el-button>
            <el-button class="color-main" @click="resetForm" type="primary">
              <i class="fa fa-refresh"></i>重置
            </el-button>
            <el-button type="success" plain @click="addCKClick">
              <i class="fa fa-plus"></i>新增出库单
            </el-button>
            <el-button class="color-vice" type="primary" @click="exportTable(1)">
              <i class="fa fa-arrow-down"></i>手动出库汇总
            </el-button>
            <el-button class="color-grey" @click="print()">
              <i class="fa fa-print"></i>
              打印
            </el-button>
          </el-form>
        </div>
      </div>
      <!-- 表格内容 -->
      <div>
        <el-table v-loading="loading" ref="multipleTableRef" :data="tableData" size="small" style="width: 100%" stripe
          border max-height="44vh" @selection-change="handleSelectionChange">
          <el-table-column width="130" prop="order_no" label="出库单号" />
          <el-table-column property="out_time" width="180" label="出库时间" />
          <el-table-column property="operator.name" label="出库人" />
          <!-- <el-table-column prop="supplier" width="200" label="供货单位" show-overflow-tooltip /> -->
          <el-table-column property="remark" label="备注" />
          <el-table-column label="出库类型" align="center" width="100">
            <template #default="scope">
              <el-tag type="danger" size="mini">{{scope.row.dict_out_type_name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column property="checkOperator.name" width="80" align="center" label="审核人" />
          <el-table-column prop="check_time" label="审核时间" width="180" />
          <el-table-column prop="check_status" align="center" width="100" label="审核状态">
            <template #default="scope">
              <el-link>{{scope.row.check_status_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="check_refuse_reason" align="center" width="150" label="审核建议">
          </el-table-column>
          <el-table-column prop="total_buy_price" align="center" width="100" label="采购总价" />
          <el-table-column prop="total_out_price" align="center" width="100" label="零售总价" />
          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template #default="scope">
              <div class="display_flex" style="align-items: center;">
                <el-link type="success" @click="doSomeThing(scope.row,3)"
                  v-if="scope.row.check_status!=2 && scope.row.check_status!=0">审核</el-link>
                <el-link type="primary" @click="doSomeThing(scope.row,2)"
                  v-if="scope.row.check_status!=2 && scope.row.check_status!=0">修改</el-link>
                <el-link type="danger" @click="delParient(scope.row)"
                  v-if="scope.row.check_status!=2 && scope.row.check_status!=0">撤销</el-link>
                <el-link @click="doSomeThing(scope.row,1)">
                  详情
                </el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
            :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalSum" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
      <printCK ref="printCKRef"></printCK>
      <addCK ref="addCKRef" @refreshDataList="tobody"></addCK>
      <checkOrEditTk ref="checkOrEditTkRef" @refreshDataList='tobody'></checkOrEditTk>
    </div>
  </div>
</template>

<script>
  import { Search, ArrowRightBold, ArrowLeftBold } from '@element-plus/icons-vue'
  import { toRefs, reactive, onMounted, nextTick, getCurrentInstance } from 'vue'
  import service from '@/utils/request'
  import BaseDialog from '@/components/Dialog/index.vue'
  import { gitDictList, TimeYear, downLoadXlsx, TimestampToTime, getLastDay, getFirstDayOfMonth } from '@/utils/tool'
  import { ElMessage, ElMessageBox,ElLoading } from 'element-plus'
  import addCK from './addCK'
  import checkOrEditTk from '../tk/checkOrEditTk'
  import printCK from '@/components/KCManager/printCK'
  export default {
    components: {
      ArrowRightBold,
      BaseDialog,
      addCK,
      checkOrEditTk,
      printCK
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1) {
      let { proxy } = getCurrentInstance()
      const state = reactive({
        formInline: {
          name: '',
          time: '',
          dict_out_type: '',
          dict_out_source: '',
          batch_no: '',
          backoff_time: [],
          backoff_check_time: []
        },
        dictList: [],
        loadings:null,
        loading: true,
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        addCKRef: null,
        checkOrEditTkRef: null,
        supplierList: [],
        check_statusList: [{
          name: '全部',
          code: ''
        }, {
          name: '待审核',
          code: '1'
        }, {
          name: '通过',
          code: '2'
        }, {
          name: '驳回',
          code: '3'
        },],
        tableData: [],
        dictCatalogType: ''
      })
      onMounted(() => {
        getSuire()
        initData()
        state.formInline.backoff_time = [getFirstDayOfMonth(), getLastDay()]
        state.dictCatalogType = props1.dictCatalogType
      })
      // 获取字典
      const initData = async () => {
        state.dictList = await gitDictList([
          props1.dictCatalogType,
          '205000000',
        ])
      }
      const getSuire = async () => {
        let res = await service.post('/api/store_enter_record/allsupplier')
        if (res.code === 0) {
          state.supplierList = res.data
        }
      }
      const resetForm = () => {
        for (const key in state.formInline) {
          state.formInline[key] = ''
        }
        // state.formInline.backoff_time = [getFirstDayOfMonth(), getLastDay()]
        state.formInline.backoff_time = [getFirstDayOfMonth(), TimestampToTime()]
        // state.formInline.backoff_check_time = [getFirstDayOfMonth(), TimestampToTime()]
        tobody()
      }
      // 获取列表
      const tobody = async () => {
        state.loading = true
        let data = {
          size: state.pageData.pageSize,
          current: state.pageData.currentPage,
          out_start_time: state.formInline.backoff_time[0],
          out_end_time: state.formInline.backoff_time[1],
          check_start_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[0] : '',
          check_end_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[1] : '',
          name: state.formInline.name,
          dict_catalog_type: props1.dictCatalogType,
          supplier: state.formInline.supplier,
          batch_no: state.formInline.batch_no,
          check_status: state.formInline.check_status,
          out_order_no: state.formInline.out_order_no,
          dict_out_source: '905110000',
          dict_out_type: state.formInline.dict_out_type
        }
        let res = await service.post('/api/storeOutRecord/getOrderList', data)
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.records
            state.pageData.totalSum = res.data.total
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
          }
        }
        state.loading = false
      }
      // 条数改变时
      const handleSizeChange = (e) => {
        state.pageData.pageSize = e
        tobody()
      }
      // 页数改变时
      const handleCurrentChange = (e) => {
        state.pageData.currentPage = e
        tobody()
      }
      // 查询
      const search = () => {
        tobody()
      }
      const timeChange = (val) => {
        state.formInline.backoff_time = val
      }
      const timeChanges = (val) => {
        state.formInline.backoff_check_time = val
      }
      const doSomeThing = (row, type) => {
        let data = {
          ...row,
          dictCatalogType: props1.dictCatalogType,
          modalName: 'CK'
        }
        state.checkOrEditTkRef.initData(data, type)
      }
      // 删除
      const delParient = (item) => {
        ElMessageBox.confirm('撤销出库单，是否确认撤销？', '操作提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await service.post('/api/storeOutRecord/deleteOrder', {
              order_id: item.id,
            })
            if (res.code === 0) {
              ElMessage.success(res.msg)
              tobody()
            }
          })
          .catch(() => { })
      }

      // 导出
      const exportTable = (row) => {
        let url = ''
        let title = ''
        let time = TimestampToTime()
        if (props1.dictCatalogType == '164000000') {
          title = `科室耗材手动出库汇总${time}.xlsx`
        } else {
          title = `科室药品手动出库汇总${time}.xlsx`
        }
        url = '/api/export/outRecordExport'
        let data = {}
        if (state.formInline.backoff_time) {
          data = {
            out_start_time: state.formInline.backoff_time[0],
            out_end_time: state.formInline.backoff_time[1],
            check_start_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[0] : '',
            check_end_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[1] : '',
            name: state.formInline.name,
            dict_catalog_type: props1.dictCatalogType,
            supplier: state.formInline.supplier,
            batch_no: state.formInline.batch_no,
            check_status: state.formInline.check_status,
            out_order_no: state.formInline.out_order_no,
            dict_out_source: '905110000',
            dict_out_type: state.formInline.dict_out_type
          }
        } else {
          data = {
            check_start_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[0] : '',
            check_end_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[1] : '',
            name: state.formInline.name,
            dict_catalog_type: props1.dictCatalogType,
            supplier: state.formInline.supplier,
            batch_no: state.formInline.batch_no,
            check_status: state.formInline.check_status,
            out_order_no: state.formInline.out_order_no,
            dict_out_source: '905110000',
            dict_out_type: state.formInline.dict_out_type
          }
        }
        downLoadXlsx(url, data, title)
      }
      //新增出库单
      const addCKClick = () => {
        let data = {
          dictCatalogType: props1.dictCatalogType
        }
        state.addCKRef.initData(data)
      }
      const print = async () => {
        ElMessage.success('请稍等...')
        // state.loadings = ElLoading.service({
        //     lock: true,
        //     text: '加载中...',
        //     background: 'rgba(0, 0, 0, 0.7)',
        //   })
        let data = {}
        if (state.formInline.backoff_time) {
          data = {
            current: 1,
            size: 10000,
            out_start_time: state.formInline.backoff_time[0],
            out_end_time: state.formInline.backoff_time[1],
            check_start_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[0] : '',
            check_end_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[1] : '',
            name: state.formInline.name,
            dict_catalog_type: props1.dictCatalogType,
            supplier: state.formInline.supplier,
            batch_no: state.formInline.batch_no,
            check_status: state.formInline.check_status,
            out_order_no: state.formInline.out_order_no,
            dict_out_source: '905110000',
            dict_out_type: state.formInline.dict_out_type,
            is_print: 1
          }
        } else {
          data = {
            current: 1,
            size: 10000,
            check_start_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[0] : '',
            check_end_time: state.formInline.backoff_check_time.length > 0 ? state.formInline.backoff_check_time[1] : '',
            name: state.formInline.name,
            dict_catalog_type: props1.dictCatalogType,
            supplier: state.formInline.supplier,
            batch_no: state.formInline.batch_no,
            check_status: state.formInline.check_status,
            out_order_no: state.formInline.out_order_no,
            dict_out_source: '905110000',
            dict_out_type: state.formInline.dict_out_type,
            is_print: 1
          }
        }
        let res = await service.post('/api/store_out_record/get_out_record_list', data)
        // state.loadings.close()
        if (res.code === 0) {
          if (res.data.total > 0) {
            let userData = JSON.parse(localStorage.getItem('ms_userData'))
            let data = {}
            if (state.formInline.backoff_time) {
              data = {
                time: state.formInline.backoff_time[0] + '~' + state.formInline.backoff_time[1],
                name: userData.name,
                drug_list: res.data.records
              }
            } else {
              data = {
                time: '',
                name: userData.name,
                drug_list: res.data.records
              }
            }
            proxy.$refs.printCKRef.initData(data)
            nextTick(() => {
              proxy.$refs.printCKRef.print()
            })
          } else {
            ElMessage.error('暂无打印数据')
          }
        }
      }
      return {
        ...toRefs(state),
        tobody,
        handleSizeChange,
        handleCurrentChange,
        search,
        timeChange,
        exportTable,
        print,
        resetForm,
        addCKClick,
        doSomeThing,
        delParient
      }
    },
  }
</script>

<style scoped lang="scss">
  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
  }

  .adviceBox {
    height: 100%;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 10px;
  }

  .demo-tabs>.el-tabs__content {
    padding: 32px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .display_flex {
    display: flex;
    justify-content: space-between;
  }

  .search-top .w-208 {
    width: 208px;

    .searchcss {
      cursor: pointer;
    }
  }

  .faicon {
    font-size: 19px;
    margin-right: 6px;
    cursor: pointer;
  }

  .title-top {
    align-items: center;
    display: flex;
  }

  .tabclis {
    height: 32px;
    background: rgba(49, 102, 174, 0.1);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    display: flex;
    padding: 3px;

    .tabclis_right {
      display: flex;
      padding-top: 2px;
    }
  }

  .pagination-box {
    &:deep(.el-input__inner) {
      padding-right: 15px !important;
    }
  }

  .w-144 {
    margin-top: 20px;
  }

  .stop {
    background-color: #f4a939;
  }

  .modify {
    background-color: #3166ae;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .top {
    /* height: 35px; */
    margin: 8px 0;
  }

  .item {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<style scoped>
  .saveRKSet {
    margin-top: 10px;
  }

  .el-input-group__append .el-select>>>.el-input__inner {
    border: none !important;
  }

  .el-form.w-144 .el-select {
    width: 100px !important;
  }

  .tables-left {
    margin-right: 10px;
    width: 30%;
  }

  .tables-right {
    margin-right: 10px;
    width: 70%;
  }

  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .margin-set {
    padding: 10px;
    float: right;
  }

  .form-two {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }

  .form-two .el-form-item {
    width: 48% !important;
  }

  .iconcliss {
    width: 32px;
    height: 32px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    color: #303030;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    font-size: 18px;
  }
</style>